import React from 'react';

import AlgoliaSearchBox from '../../../components/AlgoliaSearchBox';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from './mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { loadAndExecuteRecaptcha } from '../../../utils/recaptcha_helpers';

const createReactClass = require('create-react-class');

const CM_IN_INCH = 2.54;
const KG_IN_LB = 0.45359237;
const AVG_HEIGHTS = [169, 175, 163];
const AVG_WEIGHTS = [82.6, 88.8, 76.4];
const YOUNGEST_AGE = 13;

const ProfileEditForm = createReactClass({
  getInitialState() {
    return {
      user: this.props.currentUser,
      errors: {},
      recaptchaToken: null
    };
  },
  componentDidMount() {
    loadAndExecuteRecaptcha('editProfile', recaptchaToken => this.setState({ recaptchaToken }));
  },
  presubmitErrors() {
    const errors = {};
    if (!(this.state.user.firstName.length > 0)) {
      errors.firstName = [StringConstantsMixin.strings.REQUIRED];
    }
    if (this.state.user.firstName && this.state.user.firstName.indexOf('@') >= 0) {
      errors.firstName = ['@ not allowed'];
    }
    if (!(this.state.user.lastName.length > 0)) {
      errors.lastName = [StringConstantsMixin.strings.REQUIRED];
    }
    if (this.state.user.lastName && this.state.user.lastName.indexOf('@') >= 0) {
      errors.lastName = ['@ not allowed'];
    }
    const newPassword = $('#user_password').val();
    if (newPassword !== '' && newPassword.length < 6) {
      errors.password = [StringConstantsMixin.strings.SIGNUP.AT_LEAST_SIX_CHARS];
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return true;
    }
    this.setState({ errors: {} });
  },
  userForSave() {
    const userForSave = this.state.user;
    const newPassword = $('#user_password').val();
    if (newPassword !== '') userForSave.password = newPassword;
    userForSave.recaptcha = this.state.recaptchaToken;
    return userForSave;
  },
  handleErrors(err) {
    const { errors } = JSON.parse(err.responseText);
    if (errors) {
      this.setState({ errors: Object.assign(errors, this.state.errors) });
    } else {
      window.location.href = LanguageSupportUtil.wrapUrlSafe('/my/profile/edit?edit_fail=true', this.props.context.languageRegionCode);
    }
  },
  handleSubmit() {
    if (!this.state.recaptchaToken) {
      return;
    }
    const errors = this.presubmitErrors();
    if (errors) {
      return;
    }
    ServerCommunicationUtil.putApiEndpoint(
      '/my/profile',
      { user: this.userForSave() },
      () => {
        window.location.href = LanguageSupportUtil.wrapUrlSafe('/my/profile?edit_success=true', this.props.context.languageRegionCode);
      },
      err => {
        this.handleErrors(err);
      },
      () => {
        // complete
      }
    );
    return true;
  },
  handlePlaceSelection(algoliaObj) {
    let city;
    let state;
    let country;
    if (algoliaObj.objectID.indexOf('country') > -1) {
      country = {
        id: algoliaObj.ID,
        name: algoliaObj.name
      };
    } else if (algoliaObj.objectID.indexOf('state') > -1) {
      state = algoliaObj.name;
      country = {
        id: algoliaObj.country_id,
        name: algoliaObj.country_name
      };
    } else if (algoliaObj.objectID.indexOf('cityo') > -1) {
      city = algoliaObj.name;
      state = algoliaObj.state_name;
      country = {
        id: algoliaObj.country_id,
        name: algoliaObj.country_name
      };
    }

    const { user } = this.state;
    user.city = city;
    user.state = state;
    user.country = country;
    user.algoliaObjectId = algoliaObj.objectID;
    this.setState({ user });
  },
  calculateAge(birth_year, birth_month, birth_day) {
    const today_date = new Date();
    const today_year = today_date.getFullYear();
    const today_month = today_date.getMonth() + 1; // this function returns 0-index of month
    const today_day = today_date.getDate();
    let age = today_year - birth_year;
    if (today_month < birth_month || (today_month == birth_month && today_day < birth_day)) {
      age--;
    }
    return age;
  },
  handleYoungestAge(year, month, day) {
    if (this.calculateAge(year, month, day) < YOUNGEST_AGE) {
      const today_date = new Date();
      $('#user_birthday_2').val(today_date.getMonth() + 1); // this function returns 0-index of month
      $('#user_birthday_3').val(today_date.getDate());
    }
  },
  handleEditingChange(e) {
    const field = e.target.id;
    const { value } = e.target;
    const { user } = this.state;
    switch (field) {
      case 'user_birthday_1':
      case 'user_birthday_2':
      case 'user_birthday_3':
        var year = $('#user_birthday_1').val();
        var month = $('#user_birthday_2').val();
        var day = $('#user_birthday_3').val();
        this.handleYoungestAge(year, month, day);
        var tempBirthday = `${year}-${month}-${day}`;
        user.birthday = tempBirthday.match(/(\d+)-(\d+)-(\d+)$/) ? tempBirthday : null;
        break;
      case 'user_organization':
        user.organization = e.target.checked;
        break;
      case 'user_organization_name':
        user.organizationName = value;
        break;
      case 'user_metric':
        user.metric = e.target.checked;
        break;
      case 'user_imperial':
        user.metric = !e.target.checked;
        break;
      case 'user_speed':
        user.displaySpeed = e.target.checked;
        break;
      case 'user_pace':
        user.displaySpeed = !e.target.checked;
        break;
      case 'user_private':
        user.private = e.target.checked;
        break;
      case 'user_language':
        user.language = value;
        break;
      case 'user_about_me':
        user.aboutMe = value;
        break;
      case 'user_first_name':
        user.firstName = value;
        break;
      case 'user_last_name':
        user.lastName = value;
        break;
      case 'user_email':
        user.email = value;
        break;
      case 'user_gender':
        user.sex = value === '' ? null : value;
        break;
      case 'user_height':
        user.height = value === '' ? null : user.metric ? value : value * CM_IN_INCH;
        break;
      case 'user_weight':
        user.weight = value === '' ? null : user.metric ? value : value * KG_IN_LB;
        break;
    }

    this.setState({ user });
  },
  handleAttributeSelection(activity) {
    const { user } = this.state;
    const index = user.activities.indexOf(activity.uid);
    if (index > -1) {
      user.activities.splice(index, 1);
    } else {
      user.activities.push(activity.uid);
    }
    this.setState({ user });
  },
  createActivityInput(activity, checkedAttributes) {
    let classes = `${StringConstantsMixin.constants.XLATE.NONE} btn-slim brown activity-select`;
    let text = StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.FILTERS.ACTIVITIES, activity.name).toLowerCase();
    if (checkedAttributes.indexOf(activity.uid) >= 0) {
      classes += ' checked';
      text += ' ×';
    }
    return (
      <div className="act-holder" key={activity.name}>
        <a className={classes} data-test-id={text} onClick={this.handleAttributeSelection.bind(null, activity)}>
          {text}
        </a>
      </div>
    );
  },
  createLocationLabelText() {
    let text = StringConstantsMixin.strings.PROFILE.NO_LOCATION;
    let includePrefix = false;
    const { country } = this.state.user;
    if (country) {
      includePrefix = true;
      if (country.id === 313) {
        text = '';
      } else {
        text = country.name;
      }
      if (this.state.user.state) {
        text = country.id === 313 ? this.state.user.state : `${this.state.user.state}, ${text}`;
      }
      if (this.state.user.city) {
        text = `${this.state.user.city}, ${text}`;
      }
    }

    if (includePrefix) text = `${StringConstantsMixin.strings.PROFILE.MEMBER_LOCATION} ${text}`;

    return text;
  },
  firstNameDiv() {
    let errorMessage = '';
    let divClasses = 'input string required bottom-section';
    if (this.state.errors.firstName) {
      divClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.firstName[0]}</span>;
    }
    return (
      <div>
        <div className={divClasses}>
          <label htmlFor="user_first_name">{StringConstantsMixin.strings.SIGNUP.FIRST_NAME}</label>
          <input
            className="string required text"
            id="user_first_name"
            maxLength="40"
            name="user[first_name]"
            required="required"
            size="40"
            type="text"
            placeholder={StringConstantsMixin.strings.SIGNUP.FIRST_NAME}
            defaultValue={this.state.user.firstName}
            onChange={this.handleEditingChange}
            autoComplete="off"
          />
          {errorMessage}
        </div>
      </div>
    );
  },
  lastNameDiv() {
    let errorMessage = '';
    let divClasses = 'input string required bottom-section';
    if (this.state.errors.lastName) {
      divClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.lastName[0]}</span>;
    }
    return (
      <div>
        <div className={divClasses}>
          <label htmlFor="user_last_name">{StringConstantsMixin.strings.SIGNUP.LAST_NAME}</label>
          <input
            className="string required text"
            id="user_last_name"
            maxLength="40"
            name="user[last_name]"
            required="required"
            size="40"
            type="text"
            placeholder={StringConstantsMixin.strings.SIGNUP.LAST_NAME}
            defaultValue={this.state.user.lastName}
            onChange={this.handleEditingChange}
            autoComplete="off"
          />
          {errorMessage}
        </div>
      </div>
    );
  },
  passwordDiv() {
    let errorMessage = '';
    let divClasses = 'input password optional bottom-section';
    if (this.state.errors.password) {
      divClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.password[0]}</span>;
    }

    return (
      <div className="bottom-section">
        <div className={divClasses}>
          <label htmlFor="user_password">{StringConstantsMixin.strings.PROFILE.SET_NEW_PASSWORD}</label>
          <input
            className="password optional text"
            id="user_password"
            autoComplete="new-password"
            name="user[password]"
            size="20"
            type="password"
            placeholder={StringConstantsMixin.strings.PROFILE.SET_NEW_PASSWORD}
          />
          {errorMessage}
        </div>
      </div>
    );
  },
  emailDiv() {
    let errorMessage = '';
    let divClasses = 'input string email required bottom-section';
    if (this.state.errors.email) {
      divClasses += ' field_with_errors';
      errorMessage = <span className="error">{this.state.errors.email[0]}</span>;
    }

    return (
      <div className={divClasses}>
        <label>{StringConstantsMixin.strings.SIGNUP.EMAIL}</label>
        <input
          className="string email required text"
          id="user_email"
          maxLength="150"
          name="user[email]"
          required="required"
          size="50"
          type="email"
          placeholder={StringConstantsMixin.strings.SIGNUP.EMAIL}
          defaultValue={this.state.user.email}
          onChange={this.handleEditingChange}
          autoComplete="off"
        />
        {errorMessage}
      </div>
    );
  },
  getGenderIndex() {
    let genderIndex = 0;
    const sex = this.state.user.sex || '';
    switch (sex.toUpperCase()) {
      case 'M':
        genderIndex = 1;
        break;
      case 'F':
        genderIndex = 2;
        break;
    }
    return genderIndex;
  },
  handleHeightFocus(e) {
    const { user } = this.state;
    if (!user.height) {
      const genderIndex = this.getGenderIndex();
      user.height = AVG_HEIGHTS[genderIndex];
      this.setState({ user });
    }
  },
  handleWeightFocus(e) {
    const { user } = this.state;
    if (!user.weight) {
      const genderIndex = this.getGenderIndex();
      user.weight = AVG_WEIGHTS[genderIndex];
      this.setState({ user });
    }
  },
  calorieDiv() {
    let defaultGender = this.state.user.sex || '';
    defaultGender = defaultGender.toUpperCase();
    const genderOptions = [<option value="">{StringConstantsMixin.strings.PROFILE.UNSPECIFIED}</option>];
    genderOptions.push(this.renderSelectOption('M', StringConstantsMixin.strings.PROFILE.MALE));
    genderOptions.push(this.renderSelectOption('F', StringConstantsMixin.strings.PROFILE.FEMALE));

    const { metric } = this.state.user;
    let defaultHeight = this.state.user.height;
    defaultHeight = Math.round(metric ? defaultHeight : defaultHeight / CM_IN_INCH);
    let defaultWeight = this.state.user.weight;
    defaultWeight = Math.round(metric ? defaultWeight : defaultWeight / KG_IN_LB);
    const heightOptions = [<option value="">{StringConstantsMixin.strings.PROFILE.UNSPECIFIED}</option>];
    const weightOptions = [<option value="">{StringConstantsMixin.strings.PROFILE.UNSPECIFIED}</option>];
    let height;
    let initHeight;
    let endHeight;
    let weight;
    let initWeight;
    let endWeight;
    if (metric) {
      initHeight = 100;
      endHeight = 300;
      initWeight = 23;
      endWeight = 408;
      for (height = initHeight; height < endHeight; height++) {
        heightOptions.push(this.renderSelectOption(height, `${height} cm`));
      }
      for (weight = initWeight; weight < endWeight; weight++) {
        weightOptions.push(this.renderSelectOption(weight, `${weight} kg`));
      }
    } else {
      initHeight = 36;
      endHeight = 120;
      initWeight = 50;
      endWeight = 900;
      for (height = initHeight; height < endHeight; height++) {
        heightOptions.push(this.renderSelectOption(height, this.inchesToString(height)));
      }
      for (weight = initWeight; weight < endWeight; weight++) {
        weightOptions.push(this.renderSelectOption(weight, `${weight} lbs`));
      }
    }

    let defaultYear = '';
    let defaultMonth = '';
    let defaultDay = '';
    if (this.state.user.birthday) {
      const splitBday = this.state.user.birthday.split('-');
      defaultYear = splitBday[0];
      defaultMonth = parseInt(splitBday[1]);
      defaultDay = parseInt(splitBday[2]);
    }

    const today = new Date();
    const thisYear = today.getFullYear();
    const yearOptions = [<option value="" />];
    for (let i = thisYear - YOUNGEST_AGE; i > 1910; i--) {
      yearOptions.push(this.renderSelectOption(i, i));
    }
    const months = StringConstantsMixin.strings.MONTHS;
    const monthOptions = [<option value="" />];
    for (let i = 0; i < months.length; i++) {
      monthOptions.push(this.renderSelectOption(i + 1, months[i]));
    }
    const dayOptions = [<option value="" />];
    for (let j = 1; j < 32; j++) {
      dayOptions.push(this.renderSelectOption(j, j));
    }

    return (
      <div className="calorie-counter-info holder clear clearfix bottom-section">
        <label className="string optional">{StringConstantsMixin.strings.PROFILE.CALORIE_INFO}</label>
        <div id="calorie-counter-info">
          <label className="string optional">{StringConstantsMixin.strings.PROFILE.GENDER}</label>
          <select
            className="string optional"
            id="user_gender"
            name="user[gender]"
            defaultValue={defaultGender}
            value={defaultGender}
            onChange={this.handleEditingChange}
          >
            {genderOptions}
          </select>
          <br />
          <label className="string optional">{StringConstantsMixin.strings.PROFILE.HEIGHT}</label>
          <select
            className="string optional"
            id="user_height"
            name="user[height]"
            defaultValue={defaultHeight}
            value={defaultHeight}
            onChange={this.handleEditingChange}
            onFocus={this.handleHeightFocus}
          >
            {heightOptions}
          </select>
          <br />
          <label className="string optional">{StringConstantsMixin.strings.PROFILE.WEIGHT}</label>
          <select
            className="string optional"
            id="user_weight"
            name="user[weight]"
            defaultValue={defaultWeight}
            value={defaultWeight}
            onChange={this.handleEditingChange}
            onFocus={this.handleWeightFocus}
          >
            {weightOptions}
          </select>
          <div className="input date optional">
            <label className="date optional">{StringConstantsMixin.strings.PROFILE.BIRTHDAY}</label>
            <select
              className="date optional"
              id="user_birthday_2"
              name="user[birthday(2i)]"
              defaultValue={defaultMonth}
              onChange={this.handleEditingChange}
            >
              {monthOptions}
            </select>
            <select
              className="date optional"
              id="user_birthday_3"
              name="user[birthday(3i)]"
              defaultValue={defaultDay}
              onChange={this.handleEditingChange}
            >
              {dayOptions}
            </select>
            <select
              className="date optional"
              id="user_birthday_1"
              name="user[birthday(1i)]"
              defaultValue={defaultYear}
              onChange={this.handleEditingChange}
            >
              {yearOptions}
            </select>
          </div>
        </div>
      </div>
    );
  },
  inchesToString(inches) {
    const ft = Math.floor(inches / 12);
    const inch = Math.round(inches - ft * 12);
    return `${ft}' ${inch}\"`;
  },
  renderLanguageBlock() {
    const selectLanguageOptions = [];
    for (let i = 0; i < StringConstantsMixin.constants.SUPPORTED_LANGUAGES.length; i++) {
      selectLanguageOptions.push(
        <option
          className={StringConstantsMixin.constants.XLATE.NONE}
          key={i}
          value={StringConstantsMixin.constants.SUPPORTED_LANGUAGES[i].locale_code}
        >
          {StringConstantsMixin.constants.SUPPORTED_LANGUAGES[i].language_drop_down_name}
        </option>
      );
    }

    let defaultVal = 'en-US';
    if (this.props.currentUser.language) {
      defaultVal = this.props.currentUser.language;
    }

    return (
      <div className="holder clear clearfix bottom-section">
        <label className={`string optional ${StringConstantsMixin.constants.XLATE.NONE}`}>{StringConstantsMixin.strings.PROFILE.LANGUAGE}</label>
        <div className="flex">
          <select defaultValue={defaultVal} id="user_language" onChange={this.handleEditingChange}>
            {selectLanguageOptions}
          </select>
        </div>
      </div>
    );
  },
  renderSelectOption(value, label) {
    return <option value={`${value}`}>{label}</option>;
  },
  render() {
    const activitiesOptions = [];
    this.props.activities.forEach((item, i) => {
      activitiesOptions.push(this.createActivityInput(item, this.state.user.activities));
    });

    let organizationNameHolder = null;
    if (this.state.user.organization) {
      organizationNameHolder = (
        <div className={`input string optional ${StringConstantsMixin.constants.XLATE.NONE}`}>
          <label htmlFor="user_organization_name">{StringConstantsMixin.strings.PROFILE.ORGANIZATION_NAME}</label>
          <input
            className="string optional text"
            style={{ marginTop: '5px' }}
            id="user_organization_name"
            maxLength="100"
            name="user[organization_name]"
            size="50"
            type="text"
            placeholder={StringConstantsMixin.strings.PROFILE.ORGANIZATION_NAME}
            onChange={this.handleEditingChange}
            defaultValue={this.state.user.organizationName}
          />
        </div>
      );
    }

    const currentLocationLabel = this.createLocationLabelText();
    const formErrorMessage = this.state.errors.formError && (
      <div className="submit-buttons">
        <span className="error">{this.state.errors.formError[0]}</span>
      </div>
    );

    return (
      <div>
        <div className="form-content">
          <div className="small-content">
            <div className="image-container">
              <img src={this.props.profilePhotoPath} />
              <a href={LanguageSupportUtil.wrapUrlSafe('/my/profile/photo/edit', this.props.context.languageRegionCode)}>
                {StringConstantsMixin.strings.PROFILE.CHANGE_IMAGE}
              </a>
            </div>
          </div>
          <div className="large-content">
            {this.firstNameDiv()}
            {this.lastNameDiv()}
            <div className={this.state.user.organization ? 'clear bottom-section' : 'clear bottom-section double'}>
              <div className="org-checkbox">
                <input
                  className="boolean optional floatleft"
                  id="user_organization"
                  name="user[organization]"
                  type="checkbox"
                  defaultChecked={this.state.user.organization}
                  onChange={this.handleEditingChange}
                />
                <label className="boolean optional">
                  <p>{StringConstantsMixin.strings.PROFILE.IF_FOR_ORGANIZATION}</p>
                </label>
              </div>
              {organizationNameHolder}
            </div>
            {this.emailDiv()}
            <div className="bottom-section">
              <label htmlFor="user_about_me">{StringConstantsMixin.strings.PROFILE.ABOUT_ME}</label>
              <textarea
                className="text optional"
                cols="40"
                id="user_about_me"
                maxLength="2000"
                name="user[about_me]"
                rows="20"
                placeholder={StringConstantsMixin.strings.PROFILE.ABOUT_ME}
                defaultValue={this.state.user.aboutMe}
                onChange={this.handleEditingChange}
              />
            </div>
            <div className="clear bottom-section">
              <label className="string optional xlate-google">{currentLocationLabel}</label>
              <AlgoliaSearchBox
                algoliaIndexId={this.props.context.primaryAlgoliaIndexId}
                context={this.props.context}
                currentUser={this.props.currentUser}
                mobileBrowser={this.props.mobileBrowser}
                languageRegionCode={this.props.context.languageRegionCode}
                typeSubset={['place']}
                placeholderText={StringConstantsMixin.strings.PROFILE.CHANGE_LOCATION}
                handleLocationSelect={this.handlePlaceSelection}
                defaultLatLng={this.props.defaultLatLng}
                page="edit-profile"
              />
            </div>
            <div className="holder clear clearfix bottom-section">
              <label className="string optional">{StringConstantsMixin.strings.PROFILE.UNITS}</label>
              <div className="flex">
                <input
                  className="boolean optional floatleft"
                  id="user_imperial"
                  name="user[imperial]"
                  type="radio"
                  value="1"
                  checked={!this.state.user.metric}
                  onChange={this.handleEditingChange}
                />
                <label className="boolean optional">
                  {' '}
                  <p className="floatleft">{StringConstantsMixin.strings.PROFILE.IMPERIAL}</p>
                </label>
              </div>
              <div className="flex">
                <input
                  className="boolean optional floatleft"
                  id="user_metric"
                  name="user[metric]"
                  type="radio"
                  value="1"
                  checked={this.state.user.metric}
                  onChange={this.handleEditingChange}
                />
                <label className="boolean optional">
                  {' '}
                  <p className="floatleft">{StringConstantsMixin.strings.PROFILE.METRIC}</p>
                </label>
              </div>
            </div>
            {this.renderLanguageBlock()}
            <div className="holder clear clearfix bottom-section">
              <label className="string optional">{StringConstantsMixin.strings.PROFILE.RECORDING_PREFERENCE}</label>
              <div className="flex">
                <input
                  className="boolean optional floatleft"
                  id="user_speed"
                  name="user[speed]"
                  type="radio"
                  value="1"
                  checked={this.state.user.displaySpeed}
                  onChange={this.handleEditingChange}
                />
                <label className="boolean optional">
                  {' '}
                  <p className="floatleft">{StringConstantsMixin.strings.PROFILE.SPEED}</p>
                </label>
              </div>
              <div className="flex">
                <input
                  className="boolean optional floatleft"
                  id="user_pace"
                  name="user[pace]"
                  type="radio"
                  value="1"
                  checked={!this.state.user.displaySpeed}
                  onChange={this.handleEditingChange}
                />
                <label className="boolean optional">
                  {' '}
                  <p className="floatleft">{StringConstantsMixin.strings.PROFILE.PACE}</p>
                </label>
              </div>
            </div>
            {this.calorieDiv()}
            <div className="holder clear clearfix bottom-section">
              <div id="activities" className="filter">
                <dl className="activities light">
                  <label>{StringConstantsMixin.strings.PROFILE.FAVORITE_ACTIVITIES}</label>
                  {activitiesOptions}
                </dl>
              </div>
            </div>
            <div className="holder clear bottom-section">
              <label className="string optional">{StringConstantsMixin.strings.PROFILE.PRIVACY}</label>
              <input
                className="boolean optional floatleft"
                id="user_private"
                name="user[private]"
                type="checkbox"
                defaultChecked={this.state.user.private}
                onChange={this.handleEditingChange}
              />
              <label className="boolean optional" label="Make my profile private">
                <p id="privacy-label">{StringConstantsMixin.strings.PROFILE.MAKE_PROF_PRIVATE}</p>
              </label>
            </div>
            {this.passwordDiv()}
          </div>
          <div className="submit-buttons">
            <input
              className="blue-save btn rounded simple"
              name="commit"
              type="submit"
              value={StringConstantsMixin.strings.SAVE}
              onClick={this.handleSubmit}
              disabled={!this.state.recaptchaToken}
            />
            <a href={LanguageSupportUtil.wrapUrlSafe('/my/profile', this.props.context.languageRegionCode)} className="btn dark-grey rounded simple">
              {StringConstantsMixin.strings.CANCEL}
            </a>
          </div>
          {formErrorMessage}
        </div>
      </div>
    );
  }
});

export { ProfileEditForm };
